/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Used to save a single message sent between customers and support.
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ChatMessage
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessage
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    sender?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    senderName: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    menuOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    isSupportAgent: boolean;
}

/**
 * Check if a given object implements the ChatMessage interface.
 */
export function instanceOfChatMessage(value: object): value is ChatMessage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('senderName' in value) || value['senderName'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('isSupportAgent' in value) || value['isSupportAgent'] === undefined) return false;
    return true;
}

export function ChatMessageFromJSON(json: any): ChatMessage {
    return ChatMessageFromJSONTyped(json, false);
}

export function ChatMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'sender': json['sender'] == null ? undefined : json['sender'],
        'senderName': json['senderName'],
        'menuOrder': json['menuOrder'] == null ? undefined : json['menuOrder'],
        'message': json['message'],
        'isSupportAgent': json['isSupportAgent'],
    };
}

export function ChatMessageToJSON(json: any): ChatMessage {
    return ChatMessageToJSONTyped(json, false);
}

export function ChatMessageToJSONTyped(value?: ChatMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'sender': value['sender'],
        'senderName': value['senderName'],
        'menuOrder': value['menuOrder'],
        'message': value['message'],
        'isSupportAgent': value['isSupportAgent'],
    };
}

